import { parseButtonsPositions } from '@/utils/buttons'
import { defaultShow } from '@/conf/buttons'
import i18n from '@/utils/i18n'
import fieldsDef from '@/conf/fields'
import { getStatusTranslation } from '@/utils/bookingStatus'
import { getFieldTypeTranslation } from '@/utils/fieldTypeCodes'
import appRouter from '@/router'

export function getAutologinUrl (entity) {
  if (!entity.random_unique_chain) return null

  let href = ''
  let routeName = 'home_generic_company'
  let params = {
    companyUid: entity.random_unique_chain
  }

  if (entity.prelogged_user) {
    if (!entity.company_group.alias) return null

    routeName = 'offline_booking_prelogged_group'
    params = {
      groupAlias: entity.company_group.alias
    }
  }

  let routerLink = {
    name: routeName,
    params: params
  }

  if (window.location.origin) {
    href = window.location.origin
  } else {
    href = window.location.protocol + window.location.host
  }

  href += window.location.pathname + appRouter.resolve(routerLink).href

  return href
}

export function createShowTabs (
  translationPrefix,
  entityName,
  tabs,
  entityFields,
  entity,
  shrinkRelatedEntities = false
) {
  let tabsList = []

  if (shrinkRelatedEntities) {
    entityFields = entityFields.filter( field => {
      if (!field.uniqueRelatedEntity) return true

      return entity[field.name] !== null
    })
  }

  entity.autologin_url = getAutologinUrl(entity)

  for (let tab of tabs) {

    if (tab.type === undefined) {
      tab.type = 'main'
    }

    switch (tab.type) {
      case 'main':
        if (tab.label === undefined) {
          tab.label = '_details'
        }

        let tabRows = []

        for (let row of tab.rows) {
          let items = []
          for (let field of row) {
            let typesNotToTranslate = ['role', 'status']

            for (let entityField of entityFields) {
              if (entityField.name === field) {
                if (entityField.type === undefined) {
                  entityField.type = 'text'
                }

                let label
                let translatedLabel = translationPrefix + '.' + entityField.name

                if (i18n.te(translatedLabel) && typeof i18n.t(translatedLabel) !== 'object') {
                  label = i18n.tc(translatedLabel, 1)
                } else {
                  label = i18n.te('_' + entityField.name + '.default')
                    ? i18n.t('_' + entityField.name + '.default')
                    : i18n.tc('_' + entityField.name, 1)
                }

                let item = {
                  name: entityField.name,
                  type: entityField.type,
                  label: label
                }

                if (typesNotToTranslate.indexOf(entityField.type) !== -1 || !entityField.translate) {
                  item.value = entity[entityField.name]
                } else if (entityField.name === 'status') {
                  item.value = getStatusTranslation(entity[entityField.name])
                } else if (entityField.name === 'type' && entityName === 'bookinginputfield') {
                  item.value = getFieldTypeTranslation(entity[entityField.name])
                } else {
                  let transKey = translationPrefix + '.' + entityField.name + '.' + entity[entityField.name]
                  item.value = i18n.te(transKey)
                    ? i18n.t(transKey)
                    : i18n.t(entity[entityField.name])
                }

                if (entityField.type === 'object') {
                  if (entityField.entityName === undefined) {
                    throw new Error('Object ' + entityField.name + ' type field must define entityName')
                  } else {
                    item.entityName = entityField.entityName
                  }
                }

                // only add authorised props apart from name and type
                for (let prop of fieldsDef[entityField.type]) {
                  if (!item[prop] && entityField[prop]) {
                    item[prop] = entityField[prop]
                  }
                }

                items.push(item)
              }
            }
          }

          tabRows.push(items)
        }

        tabsList.push({
          type: tab.type,
          rows: tabRows,
          label: tab.label
        })
        break
      case 'list':
        if (tab.entityName === undefined) {
          throw new Error('List type tab must define entityName')
        }

        let label = entityName + '.tab_title.' + tab.entityName

        if (!i18n.te(label)) {
          label = '_' + tab.entityName
        }

        tabsList.push({
          type: tab.type,
          label: label,
          entityName: tab.entityName,
          overrides: tab.overrides
        })

        break
      case 'custom':
        if (tab.component === undefined) {
          throw new Error("Custom type tab must define component")
        }

        tabsList.push({
          type: tab.type,
          label: i18n.t(tab.label),
          component: tab.component
        })

        break
    }
  }

  return tabsList
}

export function getShowButtons (entityName, buttons, id, onlyShow, hotelRestrictionButton, entity = null) {
  if (buttons === undefined) {
    return {}
  } else if (buttons.default) {
    return parseButtonsPositions(defaultShow, entityName, onlyShow, id, entity)
  } else {
    if (onlyShow && buttons.allowed !== undefined && buttons.allowed.length) {
      buttons.definition = buttons.definition.filter(btn => {
        return buttons.allowed.includes(btn.name)
      })

      onlyShow = false
    }
    return parseButtonsPositions(buttons.definition, entityName, onlyShow, id, entity)
  }
}
